import {InputAddonProps} from "@/components/inputGroup/subComponents/inputAddon/InputAddon.types.ts";
import classNames from "classnames";
import {cloneElement, forwardRef, isValidElement, ReactElement} from "react";
import styles from "./InputAddon.module.scss";

export const InputAddon = forwardRef<HTMLDivElement, InputAddonProps>(
  ({children, className, disabled, "aria-invalid": ariaInvalid, hasHover}, ref) => {
    const addonClass = classNames(className, styles.inputAddon, {[styles.hasHover]: hasHover}, "input-group-text");

    if (isValidElement(children)) {
      return cloneElement(
        children as ReactElement<{
          ref?: React.Ref<unknown>;
          className?: string;
          "aria-disabled"?: boolean;
          "aria-invalid"?: boolean | "false" | "true" | "grammar" | "spelling" | undefined;
        }>,
        {
          ref,
          className: classNames(children.props.className, addonClass),
          "aria-disabled": disabled,
          "aria-invalid": ariaInvalid,
        }
      );
    }

    return (
      <div ref={ref} aria-disabled={disabled} className={addonClass}>
        {children}
      </div>
    );
  }
);
